import React, { FC } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { PREMIUM_VIDEO_LIST_REFACTOR_BASE } from "../../utils/menuPathNormalize";

/** 旧书签 `/quickVideoList?...` → 工作台内重构列表（保留 query） */
export const QuickVideoListLegacyRedirect: FC = () => {
  const [sp] = useSearchParams();
  const qs = sp.toString();
  return (
    <Navigate to={qs ? `${PREMIUM_VIDEO_LIST_REFACTOR_BASE}?${qs}` : PREMIUM_VIDEO_LIST_REFACTOR_BASE} replace />
  );
};
